import { plural } from '@/utils/plural';
import OptionalComponent from '@ui/optional-component/optional-component';
import { memo } from 'react';

const RenderHeaderLabelContent = memo(({ selectedOptionsCount }: { selectedOptionsCount: number }) => {
  return (
    <div>
      CAST{' '}
      <OptionalComponent display={(selectedOptionsCount ?? 0) > 0}>
        <span>
          • {selectedOptionsCount} {plural(selectedOptionsCount, 'PRESENTER', 'PRESENTERS')}
        </span>
      </OptionalComponent>
    </div>
  );
});

RenderHeaderLabelContent.displayName = 'RenderHeaderLabelContent';

export default RenderHeaderLabelContent;
